/**
 * #1420 — exact copy for the non-member sign-up prompt shown on /home.
 *
 * A pure constant (like `signup-incentive.ts`'s SIGNUP_INCENTIVE_REST) so the
 * wording can be pinned by a test without rendering the Radix dialog that
 * displays it. `JOIN_PROMPT_DESCRIPTION` uses `\n` for line breaks and `\n\n`
 * for the paragraph break; the component splits on `\n` to render `<br />`s.
 */
export const JOIN_PROMPT_ICON = '🌱'

export const JOIN_PROMPT_TITLE = 'Join Path Collective'

export const JOIN_PROMPT_DESCRIPTION =
  'Create your free account to save events, follow facilitators, manage your bookings and discover experiences that match you.\n\n🎁 Earn Path Coins as you participate.\nUse them to unlock rewards and help support community impact projects.'
